export const ENABLE_REDUX_LOGGER = false;

export default {};
